module.exports = __webpack_public_path__ + "static/media/v-logo-alt.630e72a5.svg";